import React,{useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import heroImg from "../img/page-bg.jpg";
import divider from "../img/divider.png";
import {Tabs, Tab, Modal, Row, Button, Col, Form, Card, Container} from "react-bootstrap";
import {NftGallery} from 'react-nft-gallery';

const bgStyle = {
  width: '100vw',
  height: '100vh',
  objectFit:'cover',
  position: 'fixed',
  left:'0'
};
const contentStyle = {
  position: 'relative',
  padding:'80px 0'
};

const formStyle = {
  display: 'flex',
  flexWrap:'wrap'
};

const successStyle = {
  textAlign:'center',
  width:'100%'
};

const Gallery = () => {
  const [key, setKey] = useState('home');

  return (
    <div className="container myGallery">
      <img style={bgStyle} src={heroImg} alt="heroImg" />
    	<div style={contentStyle} className="content-wrapper">
        <h1 className="pageHeader">MY TREASURES
        <img className="pageHeaderDivider" src={divider} alt="divider" /></h1>
        <Container>
            <Row>
                {/*<Col>
                    <div className="infoBox">
                        <h4>NFT Kingdoms</h4>
                        <p>Bringing the next million users onboard the Metis ecosystem with NFTs.</p>
                    </div>
                    <div className="infoBox">
                        <h4>Coming Soon</h4>
                        <p>NFT Kingdoms Land NFT collection with enterprise utility. NFT Kingdoms Explorer NFTs with governance utility.</p>
                    </div>
                </Col>*/}
                <Col lg={12}>
                  <Tabs
                    id="uncontrolled-tab-example"
                    className="mb-3 justify-content-center"
                    defaultActiveKey="Citizens"
                  >
                    <Tab eventKey="Citizens" title="Citizens">
                    <NftGallery ownerAddress="0xd18a67f82bf9289cfa8067852026c1f93126f502" />
                    </Tab>
                    <Tab eventKey="Treasure Chest" title="Treasure Chest">
                    <NftGallery ownerAddress="0xd18a67f82bf9289cfa8067852026c1f93126f502" />
                    </Tab>
                  </Tabs>
                </Col>
            </Row>
        </Container>
      </div>
    </div>
  );
};

export default Gallery;
